export interface OriConversationStarter {
  id: string;
  hook: string;
  syntheticMessage: string;
}

// Same set is mirrored on mobile. Hooks are curiosity-driven; the synthetic
// message is what gets sent to Ori when the user taps "Tell me more".
export const ORI_CONVERSATION_STARTERS: OriConversationStarter[] = [
  {
    id: "sleep-regularity",
    hook: "Most people focus on sleep length. But there’s another sleep factor that matters just as much for your health.",
    syntheticMessage:
      "Brief me on why sleep regularity matters for stress, not just total hours slept (5 sentences max). Keep it brief, then let’s explore how consistent my own sleep schedule is.",
  },
  {
    id: "movement-mistake",
    hook: "Movement is a great tool for stress, but more isn’t always better. Here’s how to strike the balance.",
    syntheticMessage:
      "Brief me on why regular, moderate movement builds long-term stress resilience better than occasional intense workouts (5 sentences max). Then help me think through what’s realistic for me to build into my week.",
  },
  {
    id: "sleep-debt",
    hook: "Ever wondered why you hit a wall mid-afternoon even after a full night’s sleep?",
    syntheticMessage:
      "Brief me on what 'sleep debt' actually is, and why even small amounts can affect energy and stress without someone noticing (5 sentences max). Then let’s explore how relevant this is for me.",
  },
  {
    id: "physiological-sigh",
    hook: "Got 3 minutes for a science-backed reset your body can feel immediately?",
    syntheticMessage:
      "Walk me through the physiological sigh and briefly explain why it shifts the body into a calmer state. I've got three minutes, so keep it short, then guide me through trying it right now.",
  },
  {
    id: "what-is-stress",
    hook: "You might be surprised by the ways stress shows up in your body. Want to find out what’s happening behind the scenes?",
    syntheticMessage:
      "Brief me on what happens in the body during a stress response (5 sentences max). Then let’s explore if I've noticed any of those signals in myself lately.",
  },
];
